export default "__VITE_ASSET__K6zf7o$q__"